import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/box.svg'


const _withScopeId = n => (_pushScopeId("data-v-36ba20d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "game__slider" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "game__slider-header" }, "Что собираем?", -1))
const _hoisted_3 = { class: "game__slider-container" }
const _hoisted_4 = { class: "game__slider-container-item" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "random-button__image",
  src: _imports_0
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "random-button__text" }, "Рандомный старт", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tp_arrow_button = _resolveComponent("tp-arrow-button")!
  const _component_tp_level = _resolveComponent("tp-level")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createVNode(_component_tp_arrow_button, {
          class: "tp-arrow-button-left",
          onClick: _ctx.prev
        }, null, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", { innerHTML: _ctx.html }, null, 8, _hoisted_5),
        _createVNode(_component_tp_level, { level: _ctx.level }, null, 8, ["level"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_tp_arrow_button, { onClick: _ctx.next }, null, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", {
      class: "random-button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startRandomTask && _ctx.startRandomTask(...args)))
    }, _hoisted_8)
  ]))
}